module.exports = __webpack_public_path__ + "img/医药WCA_01.2d075ee5.png";